export default {
    getDynamicTimeBalances: { method: 'get', url: 'dynamic_time_balances' },
    postDynamicTimeBalance: { method: 'post', url: 'dynamic_time_balances' },
    putDynamicTimeBalance: { method: 'put', url: 'dynamic_time_balances/{id}' },
    deleteDynamicTimeBalance: { method: 'delete', url: 'dynamic_time_balances/{id}' },
    putDynamicTimeBalanceGenerate: { method: 'put', url: 'dynamic_time_balances/{id}/generate' },
    putDynamicTimeBalanceSync: { method: 'put', url: 'dynamic_time_balances/{id}/sync' },
}